import React, { Fragment } from "react";
import type {
  RdTenure,
  SessionFunnel,
  TenureBand,
} from "../../../../../shared/metrics";
import { cohortSubtitle, funnelView, tenureLabel } from "../../../lib/metrics-display";
import { FunnelGapRow } from "./funnel-gap-row";
import { FunnelInfoPopover } from "./funnel-info-popover";
import { FunnelLegend } from "./funnel-legend";
import { FunnelStepRow } from "./funnel-step-row";
import { PanelHead } from "./panel-head";
import { TenureSwitch } from "./tenure-switch";

export function SessionFunnelPanel({
  funnel,
  tenure,
  band,
  onBandChange,
}: {
  funnel: SessionFunnel;
  tenure: RdTenure | undefined;
  band: TenureBand;
  onBandChange: (band: TenureBand) => void;
}) {
  const view = funnelView(funnel, band);

  return (
    <section className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
      <PanelHead title="Session drop-off">
        <p className="text-body text-muted-foreground">
          {cohortSubtitle(funnel.cohort)}
        </p>
        <div className="ml-auto flex items-center gap-3">
          <TenureSwitch band={band} onBandChange={onBandChange} />
          <FunnelInfoPopover source={funnel.source} />
        </div>
      </PanelHead>
      <div className="flex flex-col px-[18px] pb-4 pt-3">
        {tenure && (
          <p className="mb-3 text-right text-body-sm text-muted-foreground">
            {tenureLabel(tenure, band)}
          </p>
        )}
        {view.steps.map((step, index) => {
          const gap = view.gaps[index];

          return (
            <Fragment key={step.id}>
              <FunnelStepRow step={step} medicareCapped={view.medicareCapped} />
              {gap && <FunnelGapRow gap={gap} />}
            </Fragment>
          );
        })}
      </div>
      <FunnelLegend medicareCapped={view.medicareCapped} />
    </section>
  );
}
